import React from 'react';
import Logo from '../Logo';

const Footer = () => {
    return (
        <footer className="bg-neutral-800 border-t border-gray-700">
            <div className="max-w-7xl mx-auto px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="col-span-1">
                        <Logo width="208" height="32" textFill="white" />
                        <p className="text-gray-400 mt-4 leading-relaxed">
                            Building the future of AI-powered business solutions with cutting-edge technology 
                            that transforms customer interactions.
                        </p>
                    </div>
                    
                    <div className="col-span-1">
                        <h4 className="text-white font-semibold mb-4 font-['Montserrat']">Contact</h4>
                        <div className="space-y-3">
                            <a 
                                href="mailto:info@rocketlabventures.com" 
                                className="text-gray-400 hover:text-white transition-colors block"
                            >
                                info@rocketlabventures.com
                            </a>
                            <p className="text-gray-400">
                                Ready to transform your business with AI?
                            </p>
                        </div>
                    </div>
                    
                    <div className="col-span-1">
                        <h4 className="text-white font-semibold mb-4 font-['Montserrat']">Solutions</h4>
                        <div className="space-y-2">
                            <p className="text-gray-400">AI Customer Service</p>
                            <p className="text-gray-400">Business Automation</p>
                            <p className="text-gray-400">Voice Solutions</p>
                            <p className="text-gray-400">Enterprise Integration</p>
                        </div>
                    </div>
                </div>
                
                <div className="border-t border-gray-700 mt-8 pt-8 text-center">
                    <p className="text-gray-400">
                        &copy; 2026 Rocket Lab Ventures. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;